export function calcArrayDiffStart(
  target: any[],
  source: any[],
  primaryKey?: PropertyKey
): number {
  const isNonObjectArray = target.every(
    (item) => typeof item !== 'object' || item === null
  )
  if (isNonObjectArray) {
    const minLen = Math.min(target.length, source.length)
    for (let i = 0; i < minLen; i++) {
      if (target[i] !== source[i]) {
        return i
      }
    }
    if (target.length !== source.length) {
      return minLen
    }
    return -1
  }

  if (!primaryKey) {
    return 0
  }

  const minLen = Math.min(target.length, source.length)
  for (let i = 0; i < minLen; i++) {
    const tItem = target[i]
    const sItem = source[i]
    if (!tItem || !sItem || tItem[primaryKey] !== sItem[primaryKey]) {
      return i
    }
  }

  if (target.length !== source.length) {
    return minLen
  }

  return -1
}
